import { useEffect, useState } from "react";

import { WorkerOrderOffers } from "#/pages";
import { useApi } from "@/api";

const WorkerOrderOffersView = () => {
  const { session, worker } = useApi();

  const [loadingOffers, setLoadingOffers] = useState(false);
  const [called, setCalled] = useState(false);

  const getWorkerInvoicesList = async (id?: string) => {
    setLoadingOffers(true);
    const idtoSearch = (!id && session.user?.admin) ? "all" : id;

    await worker.getOrderOfferList(idtoSearch);
    setLoadingOffers(false);
  }

  useEffect(() => {
    if (!called) {
      setCalled(true)
      getWorkerInvoicesList();
    }
  }, [called]);


  return (
    <>
    <WorkerOrderOffers
      isAdmin={session.user?.admin ?? false}
      loading={loadingOffers}
      workerOrderOffers={worker.workerOrderOffers}
    />
    </>
  );
}

export default WorkerOrderOffersView;